export default class PvApiUnauthorizedException extends Error {
    constructor() {
        super();
        this.name = ' 401 unauthorized';
        this.message = 'Необходима авторизация';
    }
}